import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, take } from 'rxjs/operators';

import { NotificationApplicationPort } from 'application/notification/port/notification-application.port';
import { INotification } from 'domain/notification/notification';
import { UserApplicationPort } from 'user/port/user-application.port';
import { IUser } from 'user/user';

@Injectable()
export class SidebarNotificationController {
	public sessionUser$: Observable<IUser>;
	public sessionUserId$: Observable<string>;

	constructor(
		private _userApplicationPort: UserApplicationPort,
		private _notificationApplicationPort: NotificationApplicationPort
	) {
		this._initObservables();
	}

	public markNotificationRead(notification: INotification): void {
		this._notificationApplicationPort
			.markNotificationRead(notification.id)
			.pipe(take(1))
			.subscribe();
	}

	public cancelMeetingRequest(notificationId: string): Observable<void> {
		return this._notificationApplicationPort
			.cancelMeetingRequest(notificationId)
			.pipe(take(1));
	}

	private _initObservables() {
		this.sessionUser$ = this._userApplicationPort.observeSessionUser();

		this.sessionUserId$ = this._userApplicationPort
			.observeSessionUserId()
			.pipe(shareReplay({ bufferSize: 1, refCount: true }));
	}
}
